import './notFound.css';
import notFoundImage from '../../assets/not-found-image.png';


export default function NotFound(){
    return (
        <div className='not-found-container'>
            <div className='not-found-subcontainer'>
                <img src={notFoundImage} className='not-found-img'/>

                {/* <p className='not-found-title'>Página não encontrada</p> */}
                <p className='not-found-subtitle'>Não conseguimos encontrar a página que você quer acessar. Verifique se o link utilizado e tente novamente!</p>
            </div>
        </div>
    
    )
}